










































































































































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Mixins
import Context from "@/mixins/context";
import PaymentMethodsInjectorMixin from "@/mixins/paymentMethodsInjectorMixin";

// Enums/Data
import { BrandConfigKeys } from "@/data/constants";
import { GatewayTypes } from "@/data/enums";

// Types
import { IPaymentDetail } from "@/models/paymentDetails";
import { IGateway } from "@/models/gateways";
import { IClient } from "@/models/clients";

@Component
export default class ClientPaymentMethodsListing extends Mixins(
  Context,
  PaymentMethodsInjectorMixin
) {
  // Props

  @Prop({ required: true })
  public data!: IPaymentDetail[];

  @Prop({ required: true })
  public clientId!: IClient["id"];

  @Prop({ required: true })
  public isLoading!: boolean;

  /** isClickable can be used to eg disable a row click when records are staged */

  @Prop({ default: true })
  public isClickable!: boolean;

  // Methods

  public hasAlternativeMethod(methodId = "") {
    const activePaymentMethods = _.filter(
      this.data,
      ({ id, active }) => id !== methodId && active
    ).length;

    return methodId === ""
      ? this.data.length && activePaymentMethods === 1
      : !!activePaymentMethods;
  }

  public isCardGateway(gatewayType: IGateway["type"]) {
    return gatewayType === GatewayTypes.CARD;
  }

  public isInherited(clientId: IClient["id"]) {
    return clientId !== this.clientId;
  }

  // Computed

  public get canRemoveLastCard() {
    return !(
      this.$store.getters["brand/config"][
        BrandConfigKeys.PREVENT_CARD_REMOVAL_IF_LAST
      ] ?? false
    );
  }
}
